import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phonenumber'
})
export class PhonenumberPipe implements PipeTransform {

  transform(val: any): string {
      if (val && val !== null  && typeof val !== 'string') {
          return val;
      }
      let value = (!val || val === null || val === '' || val.trim().length === 0) ? '' : val;
      // if (value.length > 0 && !/^0*$/.test(value)) {
      //     value = value.replace(' ', '-');
      //     return value;
      // }
      if(value.length >= 10 && !/^0*$/.test(value)){
          let country = value.length==10?"":value.slice(0,1);
          let areaCode = value.length==10?value.slice(0,3):value.slice(1,4);
          let locationPrefix = value.length==10?value.slice(3,6):value.slice(4,7);
          let phone = value.length==10?value.slice(6):value.slice(7);
          value = country+areaCode+" "+" "+locationPrefix+" "+phone;
          return value;
      }
      else if(value.length > 0 && !/^0*$/.test(value)){
              value = value.replace(' ', '-');
              return value;
          }

      return '';
  }

}

@Pipe({
    name: 'phoneareacode'
})
export class PhoneAreaCodePipe implements PipeTransform {

    transform(val: any): string {
        if (val && val !== null  && typeof val !== 'string') {
            return val;
        }
        let value = (!val || val === null || val === '' || val.trim().length === 0) ? '' : val;
        if (value.length > 0 && !/^0*$/.test(value)) {
            value = '(' + value + ')';
            return value;
        }
        return '';
    }

}
